/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { NgOptimizedImage } from '@angular/common';
import { Component, inject, input } from '@angular/core';

import { MovieLoadingComponent } from '@usheru-hff/ui/movie-detail-page';
import { Movie } from '@usheru-hff/shared/domain';
import { SharedUtilsModule } from '@usheru-hff/shared/utils';
import { ImageService } from '@usheru-hff/shared/utils-image';

@Component({
  standalone: true,
  selector: 'ush-movie-poster',
  imports: [SharedUtilsModule, NgOptimizedImage],
  template: `<div class="movie-pic">
    <img
      [ngSrc]="movie()?.portraitPhotoUrl || portraitPlaceholder"
      [alt]="movie()?.trTitle + ' poster image'"
      width="300"
      height="400"
      style="height: auto"
      [modal]="{ src: movie()?.portraitPhotoUrl, type: 'portrait', movie: movie(), imgType: 'poster-img' }"
      addSkeleton
    />
  </div>`
})
export class MoviePosterComponent implements MovieLoadingComponent {
  private readonly imageService = inject(ImageService);

  readonly movie = input<Movie | null>(null);
  readonly isLoadingData = input(false);

  readonly portraitPlaceholder = this.imageService.portraitPlaceholder;
}
